exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".request-name[data-v-2cf7436d]{display:inline-block;font-weight:600;margin:0 .5rem}.secondary[data-v-2cf7436d]{color:#888;font-size:.8em;margin-left:1.7rem}.secondary .v-divider[data-v-2cf7436d]{display:inline-block;width:1px;background:#ccc;height:1.5em;margin:0 .5rem;vertical-align:middle}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2cf7436d","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?indentedSyntax!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/user/RequestDetail.vue
// module id = 492
// module chunks = 0